module.exports = __webpack_public_path__ + "media/images/massage/mathieu-efdfe0ce3ed858579086519011e595e8.jpg";